import { createI18n } from '../global-api/i18n';

export function initI18n (app) {
  // Expose a vue i18n instance to the app for injection into Vue components
  return createI18n(app.config.i18n).then((i18n) => {
    app.i18n = i18n;
  });
}
